import React from "react";
import { Button } from "src/components/global/Button";
import { Link } from "gatsby";
import { FaLongArrowAltRight } from "react-icons/fa";
import placeholderImg from "src/images/empire-home-slider-one.jpg";

export const Contact = () => {
  return (
    <>
      <section id="contact-section" className="bg-white relative">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1691.385509187147!2d115.9473592!3d-32.0213158!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2a32be7fe889193b%3A0x56212d97cd1db778!2s20%20Marriot%20St%2C%20Cannington%20WA%206107!5e0!3m2!1sen!2sau!4v1692764628707!5m2!1sen!2sau"
          className="w-full h-[550px]"
          loading="lazy"
          // referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </section>
    </>
  );
};
